import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';

const useStyles = makeStyles<Theme>((theme) =>
  createStyles({
    container: {
      position: 'relative',
    },

    carouselContainer: {
      marginBottom: theme.spacing(1),
    },
    dotList: {
      width: '100%',
      bottom: '0%',
      left: '0%',
    },
    item: {
      padding: '20px 0 20px 20px',
    },
  })
);

export default useStyles;
